function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $component, $helpers, JSON, Object, String, description, globalAccessType, name, saving) {
    var h = require("panel").h;
    var jade_mixins = {},
      $mixins = jade_mixins;
    jade_mixins['name-input'] = function({
      label = `Name`,
      placeHolderValue = `Untitled ${entityTypeNameTitle}`
    } = {}) {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("mp-input", {
          "attrs": __vjadeStringifyAttrsIfObj({
            placeholder: placeHolderValue,
            label: label,
            'validation-status': $helpers.getNameError() ? `invalid` : ``,
            'error-message': $helpers.getNameError() ? $helpers.getNameError() : ``,
            elref: `entityNameInput`,
            disabled: $helpers.isSavingRestricted(),
          }),
          "props": {
            value: name,
          },
          "on": {
            input: $helpers.handleNameInput,
            keydown: $helpers.handleKeydown,
          },
          "hook": {
            insert: ({
              elm
            }) => $component.setElRef(`nameInput`, elm),
            destroy: () => $component.setElRef(`nameInput`, null),
          },
        }));;
        return __jade_nodes
      }).call(this);
    };

    jade_mixins['input-description'] = function({
      text,
      learnMoreLink
    }) {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'input-description': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'input-description-text': true
            },
          }, [__vjadeSafeCode(text ? text : ``)]));
          __jade_nodes = __jade_nodes.concat((learnMoreLink) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("a", {
              "attrs": __vjadeStringifyAttrsIfObj({
                href: learnMoreLink,
                target: `_blank`
              }),
              "class": {
                'input-description-learn-more': true
              },
            }, [__vjadeSafeCode(`Learn More`)]));;
            return __jade_nodes
          }).call(this)) : undefined);;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this);
    };

    var __vjadeStringifyAttrsIfObj = function(attrs) {
      if (typeof attrs !== 'object') return attrs;
      const copy = {};
      for (const [k, v] of Object.entries(attrs)) {
        copy[k] = typeof attrs[k] === 'object' ? JSON.stringify(v) : v;
      }
      return copy;
    }

    var __vjadeSafeCode = function(code) {
      return code || String(code);
    };
    const entityTypeNameTitle = $helpers.getEntityTypeName($attr(`entity-type`), {
      titleCased: true
    });;
    const entityTypeNamePlural = $helpers.getEntityTypeName($attr(`entity-type`), {
      plural: true
    });;
    return {
      value: (h("mp-modal", {
        "attrs": __vjadeStringifyAttrsIfObj({
          open: $attr(`open`),
          'modal-title': $attr(`modal-title`),
          'modal-description': `Modal for managing ${entityTypeNamePlural}`,
        }),
        "on": {
          change: $helpers.handleModalChange
        },
        "class": {
          'modal': true,
          'create-entity-modal': true
        },
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'mp-card-header': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'mp-card-header-title': true
            },
          }, [__vjadeSafeCode($attr(`modal-title`))]));;
          return __jade_nodes
        }).call(this).filter(Boolean)));
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'mp-modal-content': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat($helpers.limitBannerRenderer());
          __jade_nodes = __jade_nodes.concat(($helpers.isSavingRestricted()) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("mp-banner", {
              "attrs": __vjadeStringifyAttrsIfObj({
                theme: `info`,
                type: `embedded`,
                'header-text': 'Upgrade to create and save cohort criteria',
                'body-text': 'When you upgrade your plan, cohorts can be created and saved to use across all reports in a project',
                ctas: `[{"text":"Upgrade","icon":"share","actionName":"clickUpsell"}]`,
                'style-override': `.banner-wrapper .banner-panel .banner-copy {width: calc(100% - 130px)}`,
              }),
              "on": {
                action: $helpers.openPricingUpsell,
              },
              "class": {
                'banner': true
              },
            }));;
            return __jade_nodes
          }).call(this)) : ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat((!$attr(`show-global-access-menu`) || $helpers.userLacksVisibilityPerms()) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("mp-sharing-banner", {
                "attrs": __vjadeStringifyAttrsIfObj({
                  'project-id': $attr(`project-id`),
                  'entity-type': $attr(`entity-type`),
                }),
                "class": {
                  'banner': true
                },
              }));;
              return __jade_nodes
            }).call(this)) : undefined);
            __jade_nodes = __jade_nodes.concat(($attr(`warning`)) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("mp-banner", {
                "attrs": __vjadeStringifyAttrsIfObj({
                  theme: `warn`,
                  type: `embedded`,
                  'body-text': $attr(`warning`),
                }),
                "class": {
                  'banner': true
                },
              }));;
              return __jade_nodes
            }).call(this)) : undefined);;
            return __jade_nodes
          }).call(this)));
          __jade_nodes = __jade_nodes.concat(($attr(`entity-type`) === `data group`) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(jade_mixins['name-input'].call(this, {
              label: `Event property`,
              placeHolderValue: `eg. company_id`
            }));
            __jade_nodes = __jade_nodes.concat(jade_mixins['input-description'].call(this, {
              text: `Type an event property to use as a Unique Group Identifier`,
              learnMoreLink: `https://help.mixpanel.com/hc/en-us/articles/360025333632#implementation`,
            }));
            __jade_nodes = __jade_nodes.concat(h("mp-input", {
              "attrs": __vjadeStringifyAttrsIfObj($helpers.getDataGroupDescriptionInputAttrs()),
              "props": {
                value: description
              },
              "on": {
                input: $helpers.handleDescriptionInput,
                keydown: $helpers.handleKeydown,
              },
              "hook": {
                insert: ({
                  elm
                }) => $component.setElRef('descriptionTextarea', elm),
                destroy: () => $component.setElRef('descriptionTextarea', null),
              },
            }));
            __jade_nodes = __jade_nodes.concat(jade_mixins['input-description'].call(this, {
              text: `The group key name that displays in the Mixpanel interface`
            }));;
            return __jade_nodes
          }).call(this)) : ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(jade_mixins['name-input'].call(this));
            __jade_nodes = __jade_nodes.concat(h("mp-input", {
              "attrs": __vjadeStringifyAttrsIfObj($helpers.getDescriptionInputAttrs()),
              "props": {
                value: description
              },
              "on": {
                input: $helpers.handleDescriptionInput,
                keydown: $helpers.handleKeydown,
              },
              "hook": {
                insert: ({
                  elm
                }) => $component.setElRef('descriptionTextarea', elm),
                destroy: () => $component.setElRef('descriptionTextarea', null),
              },
            }));;
            return __jade_nodes
          }).call(this)));
          __jade_nodes = __jade_nodes.concat(($attr(`show-global-access-menu`) && !$attr(`is-editing`) && !$helpers.userLacksVisibilityPerms()) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'global-access-container': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'label': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat("Who Can See This?");;
                return __jade_nodes
              }).call(this).filter(Boolean)));
              __jade_nodes = __jade_nodes.concat(h("mp-select", {
                "attrs": __vjadeStringifyAttrsIfObj({
                  sections: JSON.stringify($helpers.getGlobalAccessTypeSections()),
                  'selected-option': globalAccessType,
                  'label-transform': `uppercase`,
                  'size': `large`,
                  elref: `globalAccessMenu`,
                }),
                "on": {
                  change: $helpers.handleGlobalAccessTypeChange,
                },
                "class": {
                  'global-access-select': true
                },
              }));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this)) : undefined);
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'modal-footer': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'modal-actions': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(($attr(`show-share-management`)) ? ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'modal-actions-confrim-share-container': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("mp-button", {
                    "attrs": __vjadeStringifyAttrsIfObj({
                      theme: `secondary`,
                      disabled: !$helpers.formIsValid() || Boolean(saving),
                      elref: `saveAndShareButton`,
                    }),
                    "on": {
                      click: () => $helpers.saveChanges(true),
                    },
                  }, [__vjadeSafeCode(`Save and Share`)]));;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this)) : undefined);
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'modal-actions-cancel-container': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("mp-button", {
                  "attrs": __vjadeStringifyAttrsIfObj({
                    theme: `tertiary`,
                    elref: `cancelButton`,
                  }),
                  "on": {
                    click: $helpers.handleSaveModalCancel,
                  },
                  "class": {
                    'modal-actions-cancel': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat("Cancel");;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this).filter(Boolean)));
              __jade_nodes = __jade_nodes.concat(h("div", {
                "on": {
                  click: $helpers.setSubmitAttempted
                },
                "class": {
                  'modal-actions-confirm-container': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("mp-button", {
                  "attrs": __vjadeStringifyAttrsIfObj({
                    theme: `primary`,
                    disabled: !$helpers.formIsValid() || Boolean(saving),
                    icon: saving ? `spinner` : ``,
                    elref: `saveEntityButton`,
                  }),
                  "on": {
                    click: () => $helpers.saveChanges(false),
                  },
                  "class": {
                    'modal-actions-confirm': true
                  },
                }, [__vjadeSafeCode(saving ? `Saving` : `Save`)]));;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };

  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$component" in locals ? locals.$component : typeof $component !== "undefined" ? $component : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "String" in locals ? locals.String : typeof String !== "undefined" ? String : undefined, "description" in locals ? locals.description : typeof description !== "undefined" ? description : undefined, "globalAccessType" in locals ? locals.globalAccessType : typeof globalAccessType !== "undefined" ? globalAccessType : undefined, "name" in locals ? locals.name : typeof name !== "undefined" ? name : undefined, "saving" in locals ? locals.saving : typeof saving !== "undefined" ? saving : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;